import { ReactNode } from 'react'
import { cn } from '@/lib/utils'

export interface TabItem {
  key: string
  label: string
  count?: number
  icon?: ReactNode
}

interface TabsProps {
  items: TabItem[]
  value: string
  onChange: (key: string) => void
  className?: string
}

/* Estilo oficial reuse-ui (services/app-reuse-ui/src/components/Tabs.tsx): barra inferior que
   marca la pestaña activa, sin fondo tipo carpeta/pill. Copiado tal cual del design system,
   solo se le agregó soporte de ícono (no existe en la versión original) para mantener los
   íconos por pestaña que ya tenía este Home. */
export function Tabs ({ items, value, onChange, className }: TabsProps) {
  return (
    <div className={cn('flex items-center gap-0 -mb-px px-1 border-b border-slate-100', className)}>
      {items.map(({ key, label, count, icon }) => {
        const active = value === key
        return (
          <button
            key={key}
            type='button'
            onClick={() => onChange(key)}
            className={cn(
              'flex items-center gap-1.5 px-3.5 py-2.5 text-sm font-medium border-b-2 transition-colors',
              active
                ? 'border-slate-900 text-slate-900'
                : 'border-transparent text-slate-400 hover:text-slate-600'
            )}
          >
            {icon && <span className='shrink-0 [&_svg]:size-4 flex'>{icon}</span>}
            {label}
            {count !== undefined && (
              <span
                className={cn(
                  'text-[11px] px-1.5 py-0.5 rounded-full font-medium tabular-nums transition-colors',
                  active ? 'bg-slate-900 text-white' : 'bg-slate-100 text-slate-500'
                )}
              >
                {count}
              </span>
            )}
          </button>
        )
      })}
    </div>
  )
}
